import { createContext, useContext } from 'react';
import { useCarousel } from '../hooks/carousel/useCarousel';

// Define the shape of the data the context will provide.
// It's essentially the return type of your useCarousel hook.

export type CarouselContextType = ReturnType<typeof useCarousel>;

// Create the context with a default value of undefined.
export const CarouselContext = createContext<CarouselContextType | undefined>(undefined);

// Create a custom hook for easy consumption of the context.
// This is best practice!
export const useCarouselContext = () => {
  const context = useContext(CarouselContext);
  if (context === undefined) {
    throw new Error('useCarouselContext must be used within a CarouselProvider');
  }
  return context;
};